// App Version
export const APP_VERSION = '2.1.0';

// Check if we're running in Electron
export const isElectron = !!(window.electron && window.electron.isElectron === true);

// Check if we're running in Capacitor (Native Mobile)
export const isCapacitor = !!window.Capacitor;

/**
 * High-performance clinical network synchronisation.
 * Ensures that remote medical workstations correctly target the server's API port (5011).
 */
const DEFAULT_PORT = '5011';
const DEFAULT_IP = '192.168.2.15';

// Retrieve overrides from localStorage
const savedProtocol = typeof window !== 'undefined' ? localStorage.getItem('server_protocol') : null;
const savedIp = typeof window !== 'undefined' ? localStorage.getItem('server_ip') : null;
const savedPort = typeof window !== 'undefined' ? localStorage.getItem('server_port') : null;

// Clean saved IP/Hostname (strip protocol if accidentally included by user)
const cleanIp = savedIp ? savedIp.replace(/^https?:\/\//, '').replace(/\/$/, '') : null;

export const API_BASE_URL = (
  (cleanIp && savedPort)
    ? `${savedProtocol || 'http'}://${cleanIp}:${savedPort}/api`
    : (process.env.REACT_APP_API_URL || (
        isElectron
          ? (window.electron?.getApiUrl?.() || `http://localhost:${DEFAULT_PORT}/api`)
          : (isCapacitor
              ? `http://${DEFAULT_IP}:${DEFAULT_PORT}/api`
              : (window.location.port === '3011'
                  ? `${window.location.protocol}//${window.location.hostname}:${DEFAULT_PORT}/api`
                  : `${window.location.origin}/api`)
            )
      ))
);

export const getServerSettings = () => {
  return {
    protocol: localStorage.getItem('server_protocol') || 'http',
    ip: localStorage.getItem('server_ip') || '',
    port: localStorage.getItem('server_port') || DEFAULT_PORT,
    username: localStorage.getItem('server_username') || '',
    hasPassword: !!localStorage.getItem('server_password')
  };
};

export const setServerSettings = ({ protocol, ip, port, username, password }) => {
  if (protocol) localStorage.setItem('server_protocol', protocol);
  if (ip) localStorage.setItem('server_ip', ip);
  if (port) localStorage.setItem('server_port', port);
  if (username !== undefined) localStorage.setItem('server_username', username);
  if (password !== undefined) localStorage.setItem('server_password', password);
};

export const clearServerSettings = () => {
  localStorage.removeItem('server_protocol');
  localStorage.removeItem('server_ip');
  localStorage.removeItem('server_port');
  localStorage.removeItem('server_username');
  localStorage.removeItem('server_password');
};

console.log('Clinical Environment:', isElectron ? 'Electron' : isCapacitor ? 'Mobile (Capacitor)' : 'Browser');
console.log('Network API Endpoint:', API_BASE_URL);
